import { Vuex } from "@/vue.setup"
import pathify from "vuex-pathify"
import searchForm from "@/store/modules/searchForm"
import * as cmsModules from "@/store/modules/cms"
import normData from "@/store/modules/normData"
import permissions from "@/store/modules/permissions"
import formBuilding from "@/store/modules/formBuilding"

export default new Vuex.Store({
    plugins: [
        pathify.plugin,
    ],
    modules: {
		searchForm,
		...cmsModules,
		normData,
		permissions,
		formBuilding,
    },
})